// extracted by mini-css-extract-plugin
module.exports = {"Column_1_Dd":"Column1AndColumn2Filters_Column_1_Dd__1ozKz","Column_2_Dd":"Column1AndColumn2Filters_Column_2_Dd__3pvtD"};